module.exports = __webpack_public_path__ + "img/banner.a2849612.png";